<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">BRANCH EVENT</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>

                    <v-layout>
                        <v-container class="pr-0">
                            <v-flex xs6 right>
                            <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>

                    <v-layout>
                        <v-list-tile @click="tableTitle='Pending Events'">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Pending Events</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="pendingColor"><b>{{pendingCount}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile @click="tableTitle='Approved Events'"> 
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Approved Events</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="approvedColor"><b>{{approvedCount}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile @click="tableTitle='Rejected Events'">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Rejected Events</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="rejectedColor"><b>{{rejectedCount}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-layout>
                    <v-spacer></v-spacer>

                    <v-flex xs6 right>
                        <v-btn color="red accent-4" dark @click="$router.push('branch-event-add')">ADD BRANCH EVENT</v-btn>
                    </v-flex>
                </v-container>
            </v-parallax>

            <v-layout>
                <v-container>
                <v-flex xs12>
                    <v-data-table v-if="watchEvent=='pending'" :search="search" :headers="pendingHeader" :items="pendingEvents" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.branch }}</td>
                            <td class="text-xs-left">{{ props.item.event }}</td>
                            <td class="text-xs-left">{{ props.item.date }}</td>
                            <td class="text-xs-left">{{ props.item.From}}<br>{{ props.item.To}}</td>
                            <td class="text-xs-left">{{ props.item.remarks }}</td>
                            <td class="text-xs-left text-capitalize">{{ props.item.status }}</td>
                            <td class="text-xs-left">{{ props.item.requester }}</td>
                            <td class="text-xs-left">{{ props.item.createdDate }}</td>
                            <td>
                                <v-layout>
                                    <v-btn small color="red accent-4" @click="decision(props.item,'rejected')" dark>Reject</v-btn>
                                    <v-btn small color="green darken-4" @click="decision(props.item,'approved')" dark>Approve</v-btn>
                                </v-layout>
                            </td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Request Event
                            </v-alert>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>

                    <v-data-table v-else-if="watchEvent=='approved'" :search="search" :headers="headers" :items="approvedEvents" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.branch }}</td>
                            <td class="text-xs-left">{{ props.item.event }}</td>
                            <td class="text-xs-left">{{ props.item.date }}</td>
                            <td class="text-xs-left">{{ props.item.From}}<br>{{ props.item.To}}</td>
                            <td class="text-xs-left">{{ props.item.remarks }}</td>
                            <td class="text-xs-left text-capitalize">{{ props.item.status }}</td>
                            <td class="text-xs-left">{{ props.item.requester }}</td>
                            <td class="text-xs-left">{{ props.item.createdDate }}</td>
                            <td class="text-xs-left">{{ props.item.modifiedDate }}</td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Approved Events
                            </v-alert>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>

                    <v-data-table v-else-if="watchEvent=='rejected'" :headers="headers" :search="search" :items="rejectedEvents" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.branch }}</td>
                            <td class="text-xs-left">{{ props.item.event }}</td>
                            <td class="text-xs-left">{{ props.item.date }}</td>
                            <td class="text-xs-left">{{ props.item.From}}<br>{{ props.item.To}}</td>
                            <td class="text-xs-left">{{ props.item.remarks }}</td>
                            <td class="text-xs-left text-capitalize">{{ props.item.status }}</td>
                            <td class="text-xs-left">{{ props.item.requester }}</td>
                            <td class="text-xs-left">{{ props.item.createdDate }}</td>
                            <td class="text-xs-left">{{ props.item.modifiedDate }}</td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Rejected Events
                            </v-alert>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>
                </v-container>
            </v-layout>

            <v-layout>
                <v-dialog v-model="decisionDialog" max-width="500px" persistent>
                    <v-card>
                        <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="80">
                            <v-spacer></v-spacer>
                            <v-container>
                                <v-layout><br>
                                <h4 class="title font-weight-medium">{{decisionTitle}}</h4>
                                </v-layout>
                            </v-container>
                        </v-parallax>

                        <v-container grid-list>
                            <v-card-text class="subheading font-weight-regular">
                            {{decisionBody}}
                            </v-card-text>
                            <v-card-text class="subheading font-weight-regular">
                            Do you want to proceed?
                            </v-card-text>

                            <v-card-actions class="justify-center">
                                <v-btn dark color="red accent-4" @click="decisionDialog=false">NO</v-btn>
                                <v-btn dark color="blue darken-4" @click="changeEvent()">YES</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="progressDialog" persistent width="300">
                    <v-card :color="progressColor">
                        <v-card-text class="subheading white--text">{{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-snackbar v-model="snackbar" bottom right :color="snackbarColor" :timeout=3000>
                    {{snackbarMessage}} 
                    <v-btn dark small flat @click="snackbar = false">Close</v-btn>
                </v-snackbar>
            </v-layout>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import store from '../stores'
import moment from 'moment'
import _ from 'lodash'

export default {
    data() {
        return {
            tableTitle: "Pending Events",
            pendingCount: 0,
            approvedCount: 0,
            rejectedCount: 0,
            pendingColor: "red",
            approvedColor: "grey",
            rejectedColor: "grey",
            pendingHeader: [
                { text: 'Branch',  align: 'left', sortable: true, value: 'branch'},
                { text: 'Event',  align: 'left', sortable: true, value: 'event'},
                { text: 'Date',align: 'left', value: 'date' },
                { text: 'Time', align: 'center',value: 'To' },
                { text: 'Remarks', align: 'left', value: 'remarks' },
                { text: 'Status', align: 'left', value: 'status' },
                { text: 'Created By', align: 'left', value: 'requester' },
                { text: 'Created Date', align: 'left', value: 'createdDate' },
                { text: 'Action', align: 'center', value: 'name' },
            ],
            headers: [
                { text: 'Branch',  align: 'left', sortable: true, value: 'branch'},
                { text: 'Event',  align: 'left', sortable: true, value: 'event'},
                { text: 'Date',align: 'left', value: 'date',sortable: true },
                { text: 'Time', align: 'center',value: 'To' },
                { text: 'Remarks', align: 'left', value: 'remarks' },
                { text: 'Status', align: 'left', value: 'status' },
                { text: 'Created By', align: 'left', value: 'requester' },
                { text: 'Created Date', align: 'left', value: 'createdDate' },
                { text: 'Modified Date', align: 'left', value: 'modifiedDate' },
            ],
            watchEvent: "pending",
            search: "",
            allEvents: [],
            pendingEvents: [],
            approvedEvents: [],
            rejectedEvents: [],
            decisionDialog: false,
            decisionBody: "",
            decisionTitle: "",
            forChangeEvent: {},
            type: "",
            progressDialog: false,
            progressMessage: "",
            progressColor: "primary",
            snackbar: false,
            snackbarMessage: "",
            snackbarColor: "",
            customers: [],
        }
    },

    methods: {
        async fetchEvents() {
            let self = this    
            await db.collection('Events'+self.$stage).onSnapshot(function(querySnapshot) {
                self.progressMessage = "Loading..."
                self.progressColor = "primary"
                self.progressDialog = true
                self.allEvents = []
                self.pendingEvents = []
                self.approvedEvents = []
                self.rejectedEvents = []
                querySnapshot.forEach(function(doc) {
                    if (doc.data().status === "pending") {
                        self.pendingEvents.push(doc.data())
                    } else if (doc.data().status === "approved") {
                        self.approvedEvents.push(doc.data())
                    } else if (doc.data().status === "rejected") {
                        self.rejectedEvents.push(doc.data())
                    }
                    self.allEvents.push(doc.data()) 
                })

                setTimeout(() => {
                    self.progressDialog = false
                    self.pendingCount = self.pendingEvents.length
                    self.approvedCount = self.approvedEvents.length
                    self.rejectedCount = self.rejectedEvents.length
                }, 500)
            })
        },

        decision(data,type) {
            let self = this
            if (type === "approved") {
                self.decisionTitle = "Are you sure you want to approve this event?"
                self.decisionBody = "You are about to Approved this event in the list. All affected customers with appointments will receive a notification"
                self.decisionDialog = true
                self.forChangeEvent = data
                self.type = type
               
            } else {
                self.decisionTitle = "Are you sure you want to Reject this event ?"
                self.decisionBody = "You are about to Reject this event in the list. This date will still be open for customer appointment."
                self.decisionDialog = true
                self.forChangeEvent = data
                self.type = type
            } 
        },

        changeEvent() {
            let self = this
            self.progressMessage = "Updating..."
            self.progressColor = "primary"
            self.progressDialog = true

            db.collection("Events"+self.$stage).doc(self.forChangeEvent.Id)
                .update({
                    modifiedDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
                    status: self.type,
                    approvedBy: self.user.email,
                }).then(function() {
                    if (self.type === "approved") {
                        self.checkCustomersAppointment()
                    } else {
                        self.progressDialog = false
                        self.decisionDialog = false
                        self.showPending = false
                        self.snackbar = true
                        self.snackbarMessage = "Saved"
                        self.snackbarColor = "success"
                        window.location.reload()
                    }
                })
        },

        checkCustomersAppointment() {
            let self = this
            let allCustomers = []
            let count = 0
            let branchCode = self.forChangeEvent.branch.split('_')[0].trim()

            db.collection("ServiceBooking"+self.$stage)
            .where("branchCode","==",branchCode)
            .where("appointmentDate","==",self.forChangeEvent.date)
            .where("status","==","Waiting")
            .get().then(function(snapshot) {
                snapshot.forEach(function(res) {
                    allCustomers.push(res.data())
                })
            }).then(function() {
                if (allCustomers.length > 0) {
                    allCustomers.forEach(function(data) {
                        if (self.forChangeEvent.timeHold.includes(data.appointmentTime)) {
                            self.customers.push(data)
                        }
                        count ++
                        if (count === allCustomers.length) {
                            if (self.customers.length > 0) {
                                self.notifications()
                            } else {
                                self.progressDialog = false
                                self.decisionDialog = false
                                self.showPending = false
                                self.snackbar = true
                                self.snackbarMessage = "Saved! No Affected Customer."
                                self.snackbarColor = "success"
                                window.location.reload()
                            }
                        }
                    })
                } else {
                    self.progressDialog = false
                    self.decisionDialog = false
                    self.showPending = false
                    self.snackbar = true
                    self.snackbarMessage = "Saved"
                    self.snackbarColor = "success"
                    window.location.reload()
                }
            })
        },

        notifications() {
            let self = this
            let source = ""
            let urlSms = self.$smsUrl
            self.$axios.defaults.headers.common['Authorization'] = self.$smsAuthorization
            self.$axios.defaults.headers.common['Content-Type'] = self.$contentType

            if (self.forChangeEvent.branch.includes("Transcycle")) {
                source = "Transcycle"
            } else if (self.forChangeEvent.branch.includes("Powercycle")) {
                source = "Powercycle" 
            }

            self.progressMessage = "Sending Notifications"
            self.progressDialog = true
            self.customers.forEach(function(info) {
                let message = "Dear " + info.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! We are sorry to inform you that your scheduled for service on "+ info.formatedDate + " at "+ info.branch + " with Control #: " + info.transactionId + " has been cancelled due to " + self.forChangeEvent.remarks + "." + "\n\nYou can always set another schedule or feel free to visit our branches"

                var body = {
                    "source": source,
                    "destination": `63${info.userDetails.mobileNumber}`,
                    "text": message,
                    "subaccount": self.$subAccount
                }
                self.$axios.post(urlSms, body).then(response => { 
                    db.collection("ServiceBooking"+self.$stage).doc(info.transactionId)
                    .update({
                        status: "Cancelled",
                        tag: "BranchEvent"
                    }).then(function() {
                        setTimeout(() => {
                            self.decisionDialog = false
                            self.showPending = false
                            self.progressDialog = false
                            self.snackbar = true
                            self.snackbarColor = "success"
                            self.snackbarMessage = "Saved, Notification to Customer Sent."
                            window.location.reload()
                        }, 1000)
                    }).catch(function(error) {
                        self.decisionDialog = false
                        self.showPending = false
                        self.progressDialog = false
                        self.snackbar = true
                        self.snackbarColor = "success"
                        self.snackbarMessage = "Error updating customer documents."
                        console.log("Error updating custumer document")
                    })
                }).catch(function(error){
                    self.decisionDialog = false
                    self.showPending = false
                    self.progressDialog = false
                    self.snackbar = true
                    self.snackbarColor = "success"
                    self.snackbarMessage = "Error sending notifications"
                    console.log("Failed sending Notifications")
                })
            })
        },
    },

    mounted () {
        this.fetchEvents()
    },

    computed : {
        ...mapGetters(["user"]),
    },

    watch: {
        tableTitle(val) {
            if(this.tableTitle == "Pending Events"){
                this.pendingColor = "red"
                this.approvedColor = "grey"
                this.rejectedColor = "grey"
                this.watchEvent = "pending"
            } else if(this.tableTitle == "Approved Events"){
                this.pendingColor = "grey"
                this.approvedColor = "red"
                this.rejectedColor = "grey"
                this.watchEvent = "approved"
            } else if(this.tableTitle == "Rejected Events"){
                this.pendingColor = "grey"
                this.approvedColor = "grey"
                this.rejectedColor = "red"
                this.watchEvent = "rejected"
            }
        },
    },
}
</script>


